import React from 'react';
import { Navigate, Route, Routes, useMatch } from 'react-router-dom';

import ProfileMenu from '../../components/ProfileMenu';

import LayoutUser from '../../layouts/User';
import MyProfile from '../../pages/buyer/MyProfile';
import MyOrders from '../../pages/MyOrders';
import MyAddress from '../../pages/buyer/MyAddress';
import SCGFamily from '../../pages/buyer/SCGFamily';
import MyBankAccount from '../../pages/buyer/MyBankAccount';
import MyServiceJobs from '../../pages/buyer/MyServiceOrders/ServiceJob';
import BuyerConfirmPayment from '../../pages/buyer/MyServiceOrders/ConfirmPayment';
import styles from './index.module.scss';

interface Props {}

const ProfileLayout: React.FC<Props> = (props) => {
  const isMyOrderPage = useMatch('/profile/my-order');
  const isConfirmPaymentPage = useMatch({
    path: '/profile/service-orders/confirm-payment/:id',
  });
  return (
    <>
      {isMyOrderPage || isConfirmPaymentPage ? (
        <Routes>
          <Route path='my-order' element={<MyOrders />} />
          <Route
            path='service-orders/confirm-payment/:id'
            element={
              <LayoutUser>
                <BuyerConfirmPayment />
              </LayoutUser>
            }
          />
        </Routes>
      ) : (
        <LayoutUser>
          <div>
            <div className={styles.header}>โปรไฟล์ผู้ซื้อ</div>
            <div className={styles.profileLayoutContainer}>
              <ProfileMenu />
              <div className={styles.contentContainer}>
                <Routes>
                  <Route path='my-profile' element={<MyProfile />} />
                  <Route path='my-address' element={<MyAddress />} />
                  <Route path='my-bank-account' element={<MyBankAccount />} />
                  <Route path='service-orders' element={<MyServiceJobs />} />
                  <Route path='scg-family' element={<SCGFamily />} />
                  <Route
                    path='/*'
                    element={<Navigate replace to='my-profile' />}
                  />
                </Routes>
              </div>
            </div>
          </div>
        </LayoutUser>
      )}
    </>
  );
};

export default ProfileLayout;
